import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  height: 20px;
  width: 75%;
  min-width: 192px;
`;

export const Text = styled.p`
  color: #565656;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  margin-bottom: 0px;
  line-height: 20px;
  margin-right: 10px;
  width: 90px !important;
`;

export const ArrowRight = styled.img`
  cursor: ${({ active }) => (active ? 'pointer' : 'default')};
  width: 8px;
  margin-left: 6px;
  transform: ${({ active }) => (!active ? 'rotate(180deg)' : '')};
`;

export const ArrowLeft = styled.img`
  cursor: ${({ active }) => (active ? 'pointer' : 'default')};
  margin-right: 6px;
  width: 8px;
  transform: ${({ active }) => (active ? 'rotate(180deg)' : '')};
`;

export const Number = styled.span`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  
  text-align: center;

  ${({ active }) => active && 'text-decoration: underline'};

  color:  ${({ active }) => (active ? '#F07E31' : '#A1A1A1')};
  margin: 0 6px 0 6px;

  cursor: pointer;
`;
